import { render, staticRenderFns } from "./DataExpore.vue?vue&type=template&id=47c0086a"
import script from "./DataExpore.vue?vue&type=script&lang=js"
export * from "./DataExpore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports